import _styled from "styled-components";
import { autorun } from "mobx";
import { useEffect, useRef } from "react";
import styled from "styled-components";
import ViewerMode from "../../../Models/ViewerMode";
import { useViewState } from "../../Context";
import { Splitter } from "./Splitter/Splitter";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TerriaViewerWrapper = () => {
  const viewState = useViewState();
  const containerRef = useRef(null);
  useEffect(() => {
    if (viewState.terria.mainViewer.attached) {
      viewState.terria.mainViewer.detach();
    }
    if (containerRef.current) {
      viewState.terria.mainViewer.attach(containerRef.current);
    }
    return () => {
      viewState.terria.mainViewer.detach();
    };
  }, [viewState]);

  // Use an effect hook to change map container background so that we don't
  // re-render the whole component when the map container background changes.
  useMapBackground(containerRef);
  return /*#__PURE__*/_jsxs(TerrriaViewerContainer, {
    children: [/*#__PURE__*/_jsx(StyledMapPlaceholder, {
      children: "Loading the map, please wait..."
    }), /*#__PURE__*/_jsx(Splitter, {}), /*#__PURE__*/_jsx(_StyledDiv, {
      "data-testid": "mapContainer",
      id: "cesiumContainer",
      ref: containerRef
    })]
  });
};

/**
 * A hook to reactively set the map container background color from the base
 * map background color setting
 */
const useMapBackground = containerRef => {
  const terria = useViewState().terria;
  useEffect(() => {
    const disposer = autorun(() => {
      var _terria$baseMapsModel;
      // Only relevant when using leaflet mode
      if (terria.mainViewer.viewerMode !== ViewerMode.Leaflet) {
        return;
      }
      const containerBackground = (_terria$baseMapsModel = terria.baseMapsModel.baseMapItems.find(it => it.item === terria.mainViewer.baseMap)) === null || _terria$baseMapsModel === void 0 ? void 0 : _terria$baseMapsModel.backgroundColor;
      if (containerRef.current) {
        containerRef.current.style.backgroundColor = containerBackground !== null && containerBackground !== void 0 ? containerBackground : "";
      }
    });
    return disposer;
  }, [containerRef, terria]);
};
const TerrriaViewerContainer = styled.aside.withConfig({
  displayName: "TerriaViewerWrapper__TerrriaViewerContainer",
  componentId: "sc-19pci1r-0"
})(["position:absolute;top:0;left:0;bottom:0;right:0;"]);
const StyledMapPlaceholder = styled.div.withConfig({
  displayName: "TerriaViewerWrapper__StyledMapPlaceholder",
  componentId: "sc-19pci1r-1"
})(["position:absolute;top:0;left:0;bottom:0;right:0;color:black;text-align:center;width:100%;height:25%;margin:auto;@media (min-width:", "px){color:white;}"], p => p.theme.sm);
var _StyledDiv = styled("div").withConfig({
  displayName: "TerriaViewerWrapper___StyledDiv",
  componentId: "sc-19pci1r-2"
})(["cursor:auto;position:absolute;top:0;left:0;bottom:0;right:0;"]);